export enum EventModuleType {
  EVENT = 'EVENT',
  COURSE = 'COURSE',
  SCORM_COURSE = 'SCORM COURSE'
}
